import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, CalendarCheck, Wallet, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, id: "nav-dashboard" },
  { to: "/employees", label: "Employees", icon: Users, id: "nav-employees" },
  { to: "/attendance", label: "Attendance", icon: CalendarCheck, id: "nav-attendance" },
  { to: "/salary", label: "Salary", icon: Wallet, id: "nav-salary" },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="w-64 shrink-0 bg-white border-r border-slate-200 flex flex-col">
        <div className="px-6 py-6 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-slate-900 grid place-items-center text-white font-mono text-sm">P</div>
            <div>
              <div className="font-heading font-bold text-slate-900 leading-none">Payroll</div>
              <div className="text-xs text-slate-500 mt-1">Attendance & Salary</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map(({ to, label, icon: Icon, id }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={id}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-slate-900 text-white"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <Icon size={16} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200">
          <div className="px-3 py-2 text-xs text-slate-500">Signed in as</div>
          <div className="px-3 pb-3 text-sm font-medium text-slate-800 truncate">{user?.email}</div>
          <Button
            variant="outline"
            className="w-full justify-start"
            data-testid="logout-btn"
            onClick={async () => { await logout(); navigate("/login"); }}
          >
            <LogOut size={14} className="mr-2" /> Logout
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
